import React, { useState, useEffect, useRef } from "react";
import "./DropdownLists.css";
import axios from "axios";

const host = process.env.REACT_APP_HOST;

const DropdownLists = ({
  clickedKeywords,
  setClickedKeywords,
  setIsSwitchOn,
}) => {
  const [allFilters, setAllFilters] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});

  // Refs to hold references to select elements
  const selectRefs = useRef([]);
  // useEffect to reset dropdown selections and remove filters when keywords are changed
  useEffect(() => {
    selectRefs.current.forEach((selectRef, index) => {
      const filterType = Object.keys(allFilters)[index];
      const correspondingKeyword = clickedKeywords.find(
        (keyword) => selectedFilters[filterType] === keyword
      );
      if (!correspondingKeyword) {
        // Reset select value if corresponding keyword is not found
        selectRef.value = "";
        // Remove filter from selectedFilters using functional update
        setSelectedFilters((prevFilters) => {
          const { [filterType]: removedFilter, ...rest } = prevFilters;
          return rest;
        });
      }
    });
  }, [clickedKeywords]);

  //UseEffect for updating the list of avaiable dropdown filters based on user selection-updates when new selected filters are chosen
  useEffect(() => {
    console.log(selectedFilters);
    if (selectedFilters) {
      let queryString = Object.entries(selectedFilters)
        .map(
          ([filterType, value]) => `${filterType}=${encodeURIComponent(value)}`
        )
        .join("&");

      console.log(queryString);
      axios
        .get(`${host}/filters?${queryString}`)
        .then((response) => response.data)
        .then((data) => {
          setAllFilters(data);
        });
    }
    console.log(allFilters);
  }, [selectedFilters]);

  console.log(allFilters);

  /** This function sets the new array of selected filters and upades the keywords on the searchbar*/
  const handleOptionClick = (filterType, value) => {
    const newSelectedFilters = { ...selectedFilters, [filterType]: value };
    setSelectedFilters(newSelectedFilters);
    setClickedKeywords([...clickedKeywords, value]);
    setIsSwitchOn(false);
  };
  /**This funtion splits the backend formatting of words into capitalized and spaced out ones */
  const splitWord = (word) => {
    const words = word.split(/(?=[A-Z])/);
    const formattedString = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return formattedString;
  };

  // Function to clear selected filters from keywords and set select values to default labels
  const clearSelectedFiltersFromKeywords = () => {
    const updatedClickedKeywords = clickedKeywords.filter((keyword) => {
      for (const filterType in selectedFilters) {
        if (selectedFilters[filterType] === keyword) {
          return false;
        }
      }
      return true;
    });
    setClickedKeywords(updatedClickedKeywords);

    // Set select values to default labels
    selectRefs.current.forEach((selectRef, index) => {
      const filterType = Object.keys(allFilters)[index];
      selectRef.value = ""; // Reset select value
      selectRef.selectedIndex = 0; // Set selected index to default
    });

    setSelectedFilters({});
  };

  return (
    <div className="dropdown-menu">
      <div
        className="clear-dropdowns"
        onClick={clearSelectedFiltersFromKeywords}
      >
        {" "}
        X{" "}
      </div>

      {allFilters && (
        <>
          {Object.keys(allFilters).map((filterType, index) => (
            <select
              key={filterType}
              name="filterType"
              id={`filterType-${index}`}
              ref={(ref) => (selectRefs.current[index] = ref)} // Assigning ref to select element
              onChange={(e) => handleOptionClick(filterType, e.target.value)}
            >
              <option value="" selected disabled hidden>
                {splitWord(filterType)}
              </option>
              {allFilters[filterType].map(
                (value, index) =>
                  value !== null &&
                  value.trim() !== "" && (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  )
              )}
            </select>
          ))}
        </>
      )}
    </div>
  );
};
export default DropdownLists;
